export default __webpack_public_path__ + "static/media/step_2_3.063e7cba.svg";